import React from 'react';
import useSweetAlert from '../../../hooks/useSweetAlert';
import { TransportationOrderItemStatus } from '../../../app/models/TransportationOrderItemStatus';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useTransportationOrderItemService from '../../../app/services/hooks/useTransportationOrderItemService';
import { TransportationOrderItemStatuses } from '../../../app/shared/enums';

interface Props {
    transportationOrderItemId: number;
    statuses: TransportationOrderItemStatus[];
    selectedStatus: TransportationOrderItemStatus;
    reloadModule?: () => void;
    callbackSuccess?: () => void;
}

const TransportationOrderItemChangeStatus = ({
    transportationOrderItemId,
    statuses,
    selectedStatus,
    callbackSuccess,
    reloadModule
}: Props) => {
    const [selected, setSelected] = React.useState<TransportationOrderItemStatus>(selectedStatus);

    const {
        changeToPreparationStatusTransportationOrderItem,
        changeToDispatchStatusTransportationOrderItem,
        changeToFinishStatusTransportationOrderItem,
        changeToAnnulledStatusTransportationOrderItem
    } = useTransportationOrderItemService();

    const changeStatus = (value: string) => {
        if (value === selected.id) return null;
        const _status = statuses.find((status: TransportationOrderItemStatus) => status.id == value);

        if (_status?.id === TransportationOrderItemStatuses.PREPARACION) {
            changeStatusToPreparation(_status);
        } else if (_status?.id === TransportationOrderItemStatuses.DESPACHO) {
            changeStatusToDispatch(_status);
        } else if (_status?.id === TransportationOrderItemStatuses.FINALIZADO) {
            changeStatusToFinish(_status);
        } else if (_status?.id === TransportationOrderItemStatuses.ANULADO) {
            changeStatusToAnnulled(_status);
        }
    };

    const changeStatusToPreparation = (_status: any) => {
        const _text = `Está a punto de cambiar el estado de la posición de pedido #${transportationOrderItemId} a ${_status?.name}.`;
        changeStatusAlert(_status, _text, () =>
            changeToPreparationStatusTransportationOrderItem(
                transportationOrderItemId,
                _status.id,
                changeStatusEvent(_status)
            )
        );
    };

    const changeStatusToDispatch = (_status: any) => {
        const _text = `Está a punto de cambiar el estado de la posición de pedido #${transportationOrderItemId} a ${_status?.name}.`;
        changeStatusAlert(_status, _text, () =>
            changeToDispatchStatusTransportationOrderItem(
                transportationOrderItemId,
                _status.id,
                changeStatusEvent(_status)
            )
        );
    };

    const changeStatusToFinish = (_status: any) => {
        const _text = `Está a punto de cambiar el estado de la posición de pedido #${transportationOrderItemId} a ${_status?.name}.`;
        changeStatusAlert(_status, _text, () =>
            changeToFinishStatusTransportationOrderItem(
                transportationOrderItemId,
                _status.id,
                changeStatusEvent(_status)
            )
        );
    };

    const changeStatusToAnnulled = (_status: any) => {
        const _text = `Está a punto de Anular la posición de pedido #${transportationOrderItemId}, esta cambiará a estado Despacho.`;
        changeStatusAlert(_status, _text, () =>
            changeToAnnulledStatusTransportationOrderItem(
                transportationOrderItemId,
                _status.id,
                changeStatusEvent(_status)
            )
        );
    };

    const changeStatusAlert = (_status: any, _text: string, _onConfirm: () => void) => {
        useSweetAlert().requestConfirmation({
            title: '¿Está seguro?',
            text: _text,
            confirmButtonText: 'Sí, cambiar estado',
            cancelButtonText: 'Cancelar',
            onConfirm: () => {
                useSweetAlert().spinnerAlert('Cambiando estado...');
                _onConfirm(); 
            },
            onCancel: () => {
                useSweetAlert().infoAlert({
                    title: 'Cancelado',
                    text: 'El estado del pedido no se ha cambiado.'
                });
                setSelected(selectedStatus);
            }
        });
    };

    const changeStatusEvent = (_status: any) => {
        return {
            onSuccess: (response: ServiceResponse) => {
                useSweetAlert().closeSpinnerAlert();
                setSelected(_status ?? selected);

                if (reloadModule) reloadModule();
                if (callbackSuccess) callbackSuccess();

                toast.success(response.message);
            },
            onError: (response: ServiceResponse) => {
                useSweetAlert().errorAlert({
                    title: 'Error',
                    text: response.message
                });
                setSelected(selected);
                toast.error(response.message);
            }
        };
    };

    if (!selectedStatus) return null;

    return (
        <select
            className="form-control"
            value={selected.id}
            onChange={(e) => changeStatus(String(e.target.value))}
        >
            <option key={selected.id} value={selected.id}>
                {selected.name}
            </option>
            {statuses
                .filter((status) => status.id !== selected.id)
                .map((status) => (
                    <option key={status.id} value={status.id}>
                        {status.name}
                    </option>
                ))}
        </select>
    );
};

export default TransportationOrderItemChangeStatus;
